import { render, staticRenderFns } from "./Myorg.vue?vue&type=template&id=fb31a72e&scoped=true"
import script from "./Myorg.vue?vue&type=script&lang=js"
export * from "./Myorg.vue?vue&type=script&lang=js"
import style0 from "./Myorg.vue?vue&type=style&index=0&id=fb31a72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb31a72e",
  null
  
)

export default component.exports